module.exports = __webpack_public_path__ + "img/list1.6f84f62b.png";